<template>
<div class="container">
    <div class="row contact-us" id="contactUs">
                    <div class="col-md-2" style="text-alignt: right;">
                        <div><img src="../assets/img/full-brigadeiro-original.svg" width="100" class="img-fluid" /></div>
                        <div><img src="../assets/img/part-brigadeiro.svg" width="100" class="img-fluid" style="margin-top:10px;" /></div>
                        <div><img src="../assets/img/eaten-brigadeiro.svg" width="100" class="img-fluid" /></div>
                    </div>
                    <div class="col-md-10 contact-sub">
                        <div class="title-bar"></div>
                        <h2>Contact Us</h2>
                    <form role="form">
                        <div :class="{'has-danger': !name}" class="form-group">
                            <label for="name">Name (required) </label>
                            <input id="name" type="text" name="your-name" v-model="name" class="form-control" aria-required="true" aria-invalid="false" />
                        </div>
                        <div class="form-group" :class="{'has-danger': !email}">
                            <label for="email">Your Email (required)</label>
                            <input id="email" type="email" name="your-email" class="form-control" v-model="email" aria-required="true" aria-invalid="false" />
                        </div>
                        <div class="form-group">
                            <label for="phone">Your Phone #</label>
                            <input id="phone" type="tel" name="your-phone" v-model="phone"   class="form-control" aria-invalid="false" />
                        </div>
                        <div class="form-group" :class="{'has-danger': !subject}">
                            <label for="subject">Subject (Required)</label>
                            <input id="subject" type="text" name="your-subject" v-model="subject"  class="form-control" aria-invalid="false" />
                        </div>
                        <div class="form-group" :class="{'has-danger': !message}">
                            <label for="message">Message (Required)</label>
                            <textarea id="message" name="your-message" rows="10" v-model="message" class="form-control" aria-invalid="false"></textarea>
                        </div>
                        <div class="form-group" v-if="checkForm"><span id="submitButton"  v-on:click="submitData" class="form-control" >Submit</span></div>
                    </form>
                    </div>

    </div>
</div>
</template>
<script>

export default {
    name: "Contact",
    data() {
        return {
        name: null,
        email: null,
        phone: null,
        subject: null,
        message: null
        }
    },
    computed: {
        checkForm(){
            console.log(this);
                 if(!this.name || !this.email || !this.subject || !this.message)
                    return false
                else return true
            }
    },
    methods: {
        submitData(){
            fetch(`https://default962273969fe24e16b3991b23934240.58.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/0a97159db5a9401ea0c863509602cb9c/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=sbFGFiYohFxvTz2lXOcEp3b3-fnvz7Lp-gI5jSDTn_s`,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({name: this.name,email:this.email,phone: this.phone,subject:this.subject,message:this.message})
            })
            .then(response => {
                console.log(response);
                if(response.ok){
                    this.$alertify.success('Thank You! We will contact you shortly');
                    this.name = null;
                    this.email = null;
                    this.phone = null;
                    this.subject = null;
                    this.message = null;
                }
                else this.$alertify.error('Oops! Please check your information and try again')
            })
        }
    }
}
</script>
<style lang="scss">
.has-danger {
    .form-control {
        border-color: #a94442;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    }
}
.contact-us {
    margin-top: 20px;
    margin-left: 0px;
    margin-right: 0px;
    border: 1px solid #603913;
    border-radius: 10px;
    padding: 50px;
    box-shadow: 1px 2px 8px #ccc;
    .contact-sub {
        padding-right: 50px;
        padding-bottom: 50px;
        @media (max-width: 768px){
            margin-top: 15px;
        }
    }
     h2 {
        font-family: "lust-script",sans-serif;
        font-size: 3em;
        color: #300B02;
    }
}
#submitButton {
    background-color: #300B02;
    color: #FFEDD6;
    border: 1px solid #FFEDD6;
    &:hover {
        background-color: #a94442;
        cursor: pointer;
    }
}
</style>
